/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-printer': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 5.625h-1.875v-3.75H4.375v3.75H2.5c-.69 0-1.25.56-1.25 1.25v6.25c0 .69.56 1.25 1.25 1.25h1.875v3.75h11.25v-3.75H17.5c.69 0 1.25-.56 1.25-1.25v-6.25c0-.69-.56-1.25-1.25-1.25zm-11.875-2.5h8.75v2.5h-8.75v-2.5zm8.75 13.75h-8.75v-6.25h8.75v6.25zm3.125-3.75h-1.875v-3.75H4.375v3.75H2.5v-6.25h15v6.25z"/>'
  }
})
